import HonorsInfo from './HonorsInfo';

export default HonorsInfo;
